import '@inovua/reactdatagrid-enterprise/theme/default-dark.css';
import '@inovua/reactdatagrid-enterprise/index.css';
import ReactDataGrid from '@inovua/reactdatagrid-enterprise';
import { IAction, IReloadFunctions } from '../../Types';
import { Dispatch, SetStateAction, useState } from 'react';
import { scrollProps } from '../../../../../utils/ScrollProps';
import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@mui/material';
import AreYouSureModal from '../../../../../utils/AreYouSureModal';
import { deleteAction, updateAction } from '../../API/API';
import AddActionModal from '../Modals/AddActionModal';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { handleApiError } from '../../../../../utils/HandleApiError';
import useAuth from '../../../../../hooks/useAuth';
import { notifyError } from '../../../../../utils/Notification';
import useLocales from '../../../../../hooks/useLocales';
import { TypeEditInfo } from '@inovua/reactdatagrid-enterprise/types';
import * as notify from '../../../../../utils/Notification';

interface IActionsTable {
  dataLoading: boolean;
  setDataLoading: Dispatch<SetStateAction<boolean>>;
  reloadFunctions: IReloadFunctions;
}

export default function ActionsTable(props: IActionsTable) {
  const { t } = useLocales();
  const { logout } = useAuth();
  const [addActionModalState, setAddActionModalState] = useState(false);
  const [contextRow, setContextRow] = useState<IAction | null>(null);
  const [deleteModalState, setDeleteModalState] = useState(false);
  const actions = useSelector((state: RootState) => state.permissionSlice.actions);

  const renderRowContextMenu = (menuProps: any, info: any) => {
    if (info.cellProps.data.name !== 'Exists') {
      menuProps.autoDismiss = true;
      menuProps.items = [
        {
          label: t('delete'),
          onClick: () => {
            setContextRow(info.cellProps.data);
            setDeleteModalState(true);
          },
        },
        {
          label: t('copy'),
          onClick: () => {
            navigator.clipboard.writeText(info.cellProps.value); //copy cell value to clipboard
          },
        },
      ];
    }
  };

  async function deleteActionEntry() {
    try {
      if (contextRow) {
        props.setDataLoading(true);
        await deleteAction(contextRow.Id);
        props.reloadFunctions.loadActions();
        setTimeout(() => props.setDataLoading(false));
      }
    } catch (error) {
      props.setDataLoading(false);
      handleApiError(error, logout);
      notifyError(t('error_deleting_permission_action'), 'error_deleting_action');
    }
  }

  async function onEditComplete(editInfo: TypeEditInfo) {
    //@ts-ignore
    const oldValue = editInfo.data[editInfo.columnId];
    const newValue = editInfo.value; //get new value
    if (oldValue !== newValue && newValue !== '' && newValue !== null) {
      //@ts-ignore
      const data = _.cloneDeep(editInfo.data);
      data[editInfo.columnId] = newValue; //set new data
      try {
        await updateAction(data.Id, data.name, data.actionUuid);
        props.reloadFunctions.loadActions();
      } catch (error) {
        notify.notifyError(t('error_updating_data'), 'id_error_update_action');
        handleApiError(error, logout);
      }
    } else if (oldValue !== newValue && (newValue === '' || newValue == null)) {
      notify.notifyInfo(t('no_empty_fields'), 'id_info_empty_action');
    }
  }

  return (
    <>
      <ReactDataGrid
        licenseKey={process.env.REACT_APP_DATA_GRID_KEY}
        scrollProps={scrollProps}
        idProperty="Id"
        columns={[
          {
            name: 'Id',
            header: 'Id',
            headerAlign: 'center',
            visible: false,
          },
          {
            name: 'name',
            header: 'Name',
            headerAlign: 'center',
            defaultFlex: 1,
          },
          {
            name: 'actionUuid',
            header: 'UUID',
            headerAlign: 'center',
            defaultFlex: 1,
          },
        ]}
        defaultFilterValue={[
          { name: 'name', operator: 'contains', type: 'string', value: '' },
          { name: 'actionUuid', operator: 'contains', type: 'string', value: '' },
        ]}
        dataSource={actions}
        style={{ minHeight: '100%' }}
        enableColumnAutosize
        renderRowContextMenu={renderRowContextMenu}
        onEditComplete={onEditComplete}
        editable
        columnUserSelect
      />
      {!props.dataLoading && (
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', bottom: '30px', right: '30px' }}>
            <Fab onClick={() => setAddActionModalState(true)} color="primary" aria-label="add">
              <AddIcon />
            </Fab>
          </div>
        </div>
      )}
      <AddActionModal modalState={addActionModalState} setModalState={setAddActionModalState} reloadFunctions={props.reloadFunctions} />
      <AreYouSureModal modalState={deleteModalState} setModalState={setDeleteModalState} callIfYes={deleteActionEntry} />
    </>
  );
}
